import {
	IChipPrimaryField,
	LuTypeaheadChipLabelOptions
} from './lu-typeahead-chip-label/lu-typeahead-chip-label.component';
import {
	IItemLabelPrimaryField,
	LuTypeaheadItemTitleLabelOptions
} from './lu-typeahead-item-title-label/lu-typeahead-item-title-label.component';
import { LuTypeaheadOptions } from './lu-typeahead.models';

export class LuTypeaheadBuilder {
	static buildDefault(labelField: string, selectAs: string, searchPlaceholder: string): LuTypeaheadOptions {
		return LuTypeaheadBuilder.buildSimple(labelField, labelField, selectAs, labelField, searchPlaceholder);
	}

	static buildSimple(
		labelField: string,
		chipField: string,
		selectAs: string,
		filterBy: string,
		searchPlaceholder: string,
		maxSelections = 1,
		paginate = true,
		alwaysOpen = false,
		isAbsolute = true,
		initFocus = false,
		disabled = false,
		isScrollable = false,
		isMultiselectView = false,
		showFooterActions = false,
		showFilterClear = false,
		insightsService = null,
		trackingString = null
	): LuTypeaheadOptions {
		const primaryField: IItemLabelPrimaryField = {
			field: labelField
		};
		const itemOptions = new LuTypeaheadItemTitleLabelOptions(primaryField);
		const chipPrimaryField: IChipPrimaryField = {
			field: chipField
		};
		const chipOptions = new LuTypeaheadChipLabelOptions(chipPrimaryField);
		const options: LuTypeaheadOptions = {
			itemOptions: itemOptions,
			chipOptions: chipOptions,
			maxSelections: maxSelections,
			paginate: paginate,
			alwaysOpen: alwaysOpen,
			selectAs: selectAs,
			filterBy: filterBy,
			isAbsolute: isAbsolute,
			searchPlaceholder: searchPlaceholder,
			initFocus: initFocus,
			disabled: disabled,
			isScrollable: isScrollable,
			isMultiselectView: isMultiselectView,
			showFooterActions: showFooterActions,
			showFilterClear: showFilterClear,
			insightsService: insightsService,
			trackingString: trackingString
		};
		return options;
	}
}
